import { useCallback } from 'react';
import moment from 'utils/moment';
import aptActions from 'services/actions/apt';
import { calendarSelectors } from 'services/selectors/apt';
import { dateParamSignal } from 'CalendarFilter/DatePicker';
import { useAppDispatch } from 'store/hooks';

/**
 * Keep the outer scheduler calendar in sync after a time-off record is created
 * or deleted.
 *
 * Two things change, not one: the day's block hours AND the day's staff list —
 * the staff-by-appointment endpoint is date-scoped and drops a staff who is off
 * for the whole day. Refetching block hours alone leaves that staff's column on
 * the grid until the page is reloaded.
 */
export const useCalendarTimeOffSync = () => {
  const dispatch = useAppDispatch();
  const staffSize = calendarSelectors.staffSize();

  return useCallback(() => {
    const date = dateParamSignal.value?.format('YYYY-MM-DD') || moment().format('YYYY-MM-DD');
    dispatch(aptActions.blockHourList.fetch());
    dispatch(aptActions.getStaffByAppointment.fetch({ date, page: 1, size: staffSize }));
  }, [dispatch, staffSize]);
};
